import type { AppLanguage } from './languageRouting';

// <html lang> must be a valid BCP 47 tag; the two darija codes are app-internal, so they map to the same tags as
// the hreflang set. The reverse map lets a hydrating page recover its app language from the attribute.
const HTML_LANG_BY_LANGUAGE: Partial<Record<AppLanguage, string>> = { darija: 'ar-Latn-MA', darija_ar: 'ar-Arab-MA' };

export const toHtmlLang = (language: string): string => HTML_LANG_BY_LANGUAGE[language as AppLanguage] ?? language;

export const fromHtmlLang = (htmlLang: string): string =>
  (Object.keys(HTML_LANG_BY_LANGUAGE) as AppLanguage[]).find((language) => HTML_LANG_BY_LANGUAGE[language] === htmlLang) ?? htmlLang;
